import actionTypes from 'redux/actions/actionTypes'

import questionStatus from 'helpers/enums/creationTool/questionStatus'

const defaultQuestion = {
	text: '',
	textTouched: true,
	status: questionStatus.NONE,
}

const defaultState = {
	activityUid: '',
	question: defaultQuestion,
	isModified: false,
}

function initialize(state, action) {
	if (!action.activityUid) {
		return state
	}

	return {
		...state,
		activityUid: action.activityUid,
		isEdition: action.isEdition,
	}
}

function setQuestionText(state, action) {
	return {
		...state,
		question: {
			...defaultQuestion,
			text: action.payload.text,
		},
	}
}

function handleQuestionChange(state, action) {
	return {
		...state,
		isModified: true,
		question: {
			...state.question,
			text: action.value,
			status: questionStatus.CHANGED,
		},
	}
}

function handleQuestionUpdate(state) {
	return {
		...state,
		question: {
			...state.question,
			status: questionStatus.SAVING,
		},
	}
}

function handleQuestionUpdateSuccess(state) {
	return {
		...state,
		question: {
			...state.question,
			status: questionStatus.NONE,
		},
	}
}

function resetQuestionTouchStatus(state) {
	return {
		...state,
		question: {
			...state.question,
			textTouched: false,
		},
	}
}

function finalize() {
	return defaultState
}

const oeqReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_INITIALIZE:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_CREATE_SUCCESS:
		case actionTypes.VIDEO_CREATION_OEQ_INITIALIZE:
		case actionTypes.VIDEO_STANDALONE_OEQ_INITIALIZE:
			return initialize(state, action)
		case actionTypes.CREATION_TOOL_OEQ_INITIALIZE_SUCCESS:
			return setQuestionText(state, action)
		case actionTypes.CREATION_TOOL_OEQ_QUESTION_CHANGE:
			return handleQuestionChange(state, action)
		case actionTypes.CREATION_TOOL_OEQ_QUESTION_AUTOSAVE:
			return handleQuestionUpdate(state, action)
		case actionTypes.CREATION_TOOL_OEQ_QUESTION_UPDATE_SUCCESS:
			return handleQuestionUpdateSuccess(state, action)
		case actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_SAVE_ERROR:
			return resetQuestionTouchStatus(state, action)
		case actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_FINALIZE:
		case actionTypes.VIDEO_STANDALONE_OEQ_FINALIZE:
			return finalize()
		default: return state
	}
}
export default oeqReducer
